import { createContext, use } from "react";
import type { RouteObject } from "react-router";

/**
 * Env-scoped page routes for modal previews (LinkWithModalModal, etc.).
 * Provided by AppLoader to avoid a circular dependency between the modal and envPageRoutes.
 */
export const ModalRoutesContext = createContext<RouteObject[]>([]);

export function useModalRoutes(): RouteObject[] {
  const routes = use(ModalRoutesContext);

  if (import.meta.env.DEV && routes.length === 0) {
    console.warn(
      "useModalRoutes: no routes provided. Ensure a <ModalRoutesContext> provider wraps this subtree."
    );
  }

  return routes;
}
